
export const TEMPLATE_ID_AUTH = "template-auth";
export const TEMPLATE_ID_DEFAULT = "template-default";
export const TEMPLATE_ID_TASK = "template-task";